module.exports = "/_next/static/images/wood_top-76cf7bac0721e9f82e79591e12465fea.jpg";